import { useMemo } from "react"
import { FlexGridItem, useStyletron } from "@mezo-org/mezo-clay"

import { SIDEBAR_NAVIGATION_WIDTH } from "#/shared/constants"
import { useMobileScreen } from "#/shared/hooks"

import DashboardHeaderAccount from "./DashboardHeaderAccount"
import DashboardHeaderActions from "./DashboardHeaderActions"
import DashboardHeaderLogo from "./DashboardHeaderLogo"
import DashboardHeaderTitle from "./DashboardHeaderTitle"
import DashboardHeaderWrapper from "./DashboardHeaderWrapper"

export default function DashboardHeader() {
  const isMobileScreen = useMobileScreen()

  const [, theme] = useStyletron()

  const paddingInline = useMemo(
    () => (isMobileScreen ? theme.sizing.scale1000 : theme.sizing.scale1600),
    [isMobileScreen, theme],
  )

  return (
    <DashboardHeaderWrapper items={4} paddingRight={paddingInline}>
      <FlexGridItem
        overrides={{
          Block: {
            style: () => ({
              maxWidth: SIDEBAR_NAVIGATION_WIDTH,
              width: "100%",
              flexGrow: 0,
              display: "flex",
              justifyContent: "center",
            }),
          },
        }}
      >
        <DashboardHeaderLogo />
      </FlexGridItem>
      <FlexGridItem
        overrides={{ Block: { style: () => ({ paddingLeft: paddingInline }) } }}
      >
        <DashboardHeaderTitle />
      </FlexGridItem>
      <FlexGridItem
        overrides={{
          Block: {
            style: () => ({ width: "auto", flexGrow: 0 }),
          },
        }}
      >
        <DashboardHeaderActions />
      </FlexGridItem>
      <FlexGridItem
        overrides={{
          Block: {
            style: () => ({
              width: "auto",
              display: "inline-flex",
              flexGrow: 0,
            }),
          },
        }}
      >
        {!isMobileScreen && <DashboardHeaderAccount />}
      </FlexGridItem>
    </DashboardHeaderWrapper>
  )
}
